<template>
	<div
		class="news_listing scrollanchor"
		ref="news_listing"
	>
		<div class="container">
			<div class="cats-wrapper">
				<h4>Filter Articles</h4>

				<ul
					class="filter-cats"
					v-if="(show_filter === 'on' || show_filter === '1') && paginatedData.length >= 0 && Object.keys(parsedCategories).length > 0"
				>
					<a
						v-on:click="currentFilter = 'all'"
						:class="{ current: currentFilter == 'all' }"
						class='transition-ignore'
					>All</a>
					<a
						v-for="(category, index) in parsedCategories"
						:key="index"
						:id="category.id"
						v-on:click="currentFilter === category.slug ? currentFilter = 'all' : currentFilter = category.slug"
						class='transition-ignore'
						:class="{ current: category.slug == currentFilter }"
						v-html="category.name"
					></a>
				</ul>

				<div class="search-container">
					<input
						type="text"
						v-model="searchQueryTemp"
						placeholder="Search →"
						class="search-input"
						@keyup.enter="applySearch"
					/>

					<div class="search-button">
						<svg
							@click="applySearch"
							width="20"
							height="20"
							viewBox="0 0 20 20"
							fill="none"
							xmlns="http://www.w3.org/2000/svg"
						>
							<path
								fill-rule="evenodd"
								clip-rule="evenodd"
								d="M8.5 2C4.91014 2 2 4.91014 2 8.5C2 12.0898 4.91015 15 8.5 15C12.0898 15 15 12.0898 15 8.5C15 4.91015 12.0898 2 8.5 2ZM0 8.5C0 3.80558 3.80558 0 8.5 0C13.1944 0 17 3.80557 17 8.5C17 10.4903 16.3159 12.3209 15.17 13.7694L19.706 18.2918C20.0972 18.6818 20.0981 19.3149 19.7082 19.706C19.3182 20.0972 18.6851 20.0981 18.294 19.7082L13.7542 15.182C12.3081 16.3207 10.4834 17 8.5 17C3.80557 17 0 13.1944 0 8.5Z"
								fill="#2713CE"
							/>
						</svg>
					</div>

				</div>
			</div>
		</div>

		<div class="post_tiles container">
			<transition name="fade">
				<div
					class="overlay"
					v-if="busy === true"
				>
					<loading-animation></loading-animation>
				</div>
			</transition>

			<template v-if="busy != true">
				<post-tile
					v-for="(post, index) in paginatedData"
					:key="index"
					:name="post.title"
					:short_description="post.excerpt"
					:image="post.image"
					:permalink="post.permalink"
					:class="post.post_type"
					:tag="post.category"
					:post_type="post.post_type"
					:video='false'
					:index="'index_' + index"
					data-aos="fade-up"
					data-aos-duration="300"
					:data-aos-offset="50"
					:data-aos-delay="index * 50"
				></post-tile>
			</template>

			<div
				class="pagination_container"
				v-if="pageCount !== 1 && show_pagination === '1' && paginatedData.length !== 0 && busy != true"
			>
				<a
					v-if="pageNumber !== 0"
					@click="pageNumber--"
					class="prev page-numbers-exterior"
				>
					<svg
						xmlns="http://www.w3.org/2000/svg"
						width="13.554"
						height="12.554"
						viewBox="0 0 13.554 12.554"
					>
						<g
							id="Arrow_Short"
							data-name="Arrow Short"
							transform="translate(0 0.53)"
						>
							<path
								id="Arrow-basic"
								d="M8.127,0V8.127H0"
								transform="translate(1 5.746) rotate(-45)"
								fill="none"
								stroke="#000"
								stroke-width="1.5"
							/>
							<line
								id="Line_251"
								data-name="Line 251"
								x1="12.5"
								transform="translate(0 5.796)"
								fill="none"
								stroke="#000"
								stroke-width="1.5"
							/>
						</g>
					</svg>
					<span>Previous</span>
				</a>

				<ul class="page-numbers">
					<li
						v-for="(post, index) in pageCount"
						:key="index"
					>
						<template v-if="shouldDisplayPage(index)">
							<a
								@click="pageNumber = index"
								class="page-numbers"
								:class="{ current: index === pageNumber }"
								v-html="index + 1"
							></a>
						</template>
						<template v-else-if="shouldDisplayEllipsis(index)">
							<span class="ellipsis">...</span>
						</template>
					</li>
				</ul>

				<a
					v-if="pageNumber !== pageCount - 1"
					@click="pageNumber++"
					class="next page-numbers-exterior"
				>
					<span>Next</span>
					<svg
						xmlns="http://www.w3.org/2000/svg"
						width="13.554"
						height="12.554"
						viewBox="0 0 13.554 12.554"
					>
						<g
							id="Arrow_Short"
							data-name="Arrow Short"
							transform="translate(0 0.53)"
						>
							<path
								id="Arrow-basic"
								d="M8.127,0V8.127H0"
								transform="translate(1 5.746) rotate(-45)"
								fill="none"
								stroke="#000"
								stroke-width="1.5"
							/>
							<line
								id="Line_251"
								data-name="Line 251"
								x1="12.5"
								transform="translate(0 5.796)"
								fill="none"
								stroke="#000"
								stroke-width="1.5"
							/>
						</g>
					</svg>
				</a>
			</div>
		</div>
	</div>
</template>



<script>
import ArrowNavyNorm from '../../images/arrow-basic.svg';
import ArrowNavyLong from '../../images/arrow-basic.svg';
import PostTile from './PostTile.vue';
import LoadingAnimation from './LoadingAnimation.vue';

export default {
	/* eslint-disable no-undef */

	data() {
		return {
			arrowNavyNorm: ArrowNavyNorm,
			arrowNavyLong: ArrowNavyLong,
			show: false,
			currentFilter: 'all',
			currentSort: this.sort_default,
			visible: true,
			pageNumber: 0, // default to page 0
			paginatedStuff: this.pagination(),
			number_of_posts: this.number_posts_per_page(),
			dropdownClicked: false,
			window: {
				width: 0,
				height: 0,
			},
			busy: false,
			searchQueryTemp: '', // Add this line
			searchQuery: '', // Add this line
		};
	},

	props: {
		size: {
			default: 'one',
		},
		posts: {},
		categories: {},
		show_filter: {},
		show_title: {},
		title: {},
		show_pagination: {},
		show_sort: {},
		data_size: {
			type: Number,
			required: false,
			default: 2,
		},
		posts_per_page: {
			required: true,
			default: 7,
		},
		button_type: {
			default: 'normal',
		},
		no_posts_message: {
			default: 'We apologise, no posts match your criteria!',
		},
		asset_url: {},
		sort_default: {
			default: 'latest-oldest',
		},
	},

	computed: {
		showingOf() {
			let page = this.pageNumber + 1;
			let totalCount = this.filteredPosts.length; // Change this line
			let postsPerPage = this.number_of_posts;

			let startCount = !page ? 1 : (page - 1) * postsPerPage + 1;
			let endCount = startCount + (postsPerPage - 1);

			if (endCount > totalCount) {
				endCount = totalCount;
			}

			return 'Showing ' + startCount + '-' + endCount + ' of ' + totalCount;
		},

		pageCount() {
			let l = this.filteredPosts.length, // Change this line
				s = this.number_of_posts;
			return Math.ceil(l / s);
		},

		paginatedData() {
			const start = this.pageNumber * this.number_posts_per_page(),
				end = start + this.number_of_posts;
			return this.filteredPosts.slice(start, end); // Change this line
		},

		parsedCategories() {
			if (this.categories) {
				return JSON.parse(this.categories);
			} else {
				return null;
			}
		},

		parsedPosts() {
			if (this.posts) {
				return JSON.parse(this.posts);
			} else {
				return null;
			}
		},

		// eslint-disable-next-line no-mixed-spaces-and-tabs
		filteredCategory() {
			// Existing logic for filtering by category and sorting
			var vm = this;
			var category = vm.currentFilter;
			var sort = vm.currentSort;
			var thePosts = vm.parsedPosts;

			// First, filter by the selected category (if not 'all')
			let filteredPosts =
				category === 'all'
					? thePosts
					: thePosts.filter(function (article) {
							const catCheck = (element) => element['slug'] === category;
							let articleCategoryArray = Array.isArray(article.category)
								? Array.from(article.category)
								: [];
							return articleCategoryArray.some(catCheck);});

			// Then, sort so that "Featured" articles always come first
			filteredPosts.sort((a, b) => {
				const isFeaturedA = a.category.some((cat) => cat.slug === 'featured');
				const isFeaturedB = b.category.some((cat) => cat.slug === 'featured');

				// Featured articles go first
				if (isFeaturedA && !isFeaturedB) return -1;
				if (!isFeaturedA && isFeaturedB) return 1;

				// Otherwise, apply the selected sort order
				if (sort === 'latest-oldest')
					return new Date(b.date) - new Date(a.date);
				if (sort === 'oldest-latest')
					return new Date(a.date) - new Date(b.date);
				if (sort === 'alpha') return a.title.localeCompare(b.title);
				if (sort === 'random') return Math.random() - 0.5;

				return 0; // Default, no sorting
			});

			return filteredPosts;
		},

		filteredPosts() {
			let categoryFilteredPosts = this.filteredCategory; // Get category filtered posts
			if (this.searchQuery) {
				return categoryFilteredPosts.filter((post) =>
					post.title.toLowerCase().includes(this.searchQuery.toLowerCase()),
				);
			}
			return categoryFilteredPosts;
		},
	},

	watch: {
		currentFilter() {
			this.loadPosts();
		},

		pageNumber() {
			this.loadPosts();
		},
	},

	methods: {
		async scrollPage() {
			await this.sleep(0);
			let scrollAnchor = document.querySelector('.scrollanchor');
			let scrollAnchorOffset = scrollAnchor.offsetTop;
			if (scrollAnchor) {
				window.scrollTo({ top: scrollAnchorOffset - 250, behavior: 'smooth' });
			}
		},

		nextPage() {
			this.pageNumber++;
		},
		prevPage() {
			this.pageNumber--;
		},

		pagination() {
			let parsed = JSON.parse(this.posts);
			return parsed;
		},

		number_posts_per_page() {
			let the_result = JSON.parse(this.posts_per_page);
			return the_result.number;
		},

		handleResize() {
			this.window.width = window.innerWidth;
			this.window.height = window.innerHeight;
		},

		sleep(ms) {
			return new Promise((resolve) => setTimeout(resolve, ms));
		},

		applySearch() {
			this.busy = true; // Set busy to true
			this.searchQuery = this.searchQueryTemp;

			setTimeout(() => {
				this.busy = false; // Reset busy to false after search is done
			}, 1000); // Adjust the timeout as needed
		},

		shouldDisplayPage(index) {
			const { pageNumber, pageCount } = this;

			if (index === 0 || index === pageCount - 1) {
				return true; // Always display the first and last page
			}

			// if (index <= 2) {
			// 	return true; // Initially display the first 3 pages and the last page
			// }

			if (Math.abs(index - pageNumber) <= 1) {
				return true; // Display the current page and adjacent pages
			}

			if (pageNumber >= 2 && index === pageNumber - 2) {
				return true; // Display the page before the current page when 4 pages before the last page
			}

			if (pageNumber <= pageCount - 3 && index === pageNumber + 2) {
				return true; // Display the page after the current page when 4 pages before the last page
			}

			if (index === 1 && pageNumber === 3) {
				return true; // Display the second page when on the third page
			}

			return false; // Replace all other pages with ellipses
		},

		shouldDisplayEllipsis(index) {
			const { pageNumber, pageCount } = this;
			if (
				(index === pageNumber - 3 &&
					pageNumber >= Math.floor(pageNumber / 2)) ||
				(index === pageNumber + 3 && pageNumber <= pageCount - 5)
			) {
				return true;
			}
			return false;
		},

		checkQueryString() {
			const urlParams = new URLSearchParams(window.location.search);
			const category = urlParams.get('category');

			if (category) {
				this.currentFilter = category;
			}
		},

		async loadPosts() {
			this.busy = true;
			await this.sleep(50);
			window.scrollTo({ top: 0, behavior: 'smooth' });
			await this.sleep(50);
			this.busy = false;
		},
	},

	components: {
		PostTile,
		LoadingAnimation,
	},

	created() {
		this.currentFilter = 'all';
		window.addEventListener('resize', this.handleResize);
		window.addEventListener('load', this.handleResize);
		window.dispatchEvent(new Event('resize'));
		this.handleResize();
	},

	destroyed() {
		window.removeEventListener('scroll', this.didScroll);
		window.removeEventListener('resize', this.handleResize);
	},
	mounted() {
		this.handleResize();
		this.checkQueryString();
	},
	change() {
		window.dispatchEvent(new Event('resize'));
		this.handleResize();
	},
};
</script>

<style lang="scss" scoped>
@import '../../styles/common/variables';

.news_listing {
	// margin-top: var(--gutter-tablet-desktop);
	// margin-bottom: 72px;
	grid-column: span 12;
	position: relative;
	overflow: hidden;
	padding-top: 60px;

	.blog &,
	.page &,
	.home &,
	.single & {
		grid-column: span 9;
		border-left: 1px solid var(--light-grey);
		border-right: 1px solid var(--light-grey);
		position: relative;
		padding-bottom: 50px;
		padding-right: 40px;
		padding-left: 40px;

		@media (max-width: $mobile-xl) {
			grid-column: span 4;
			padding-right: unset;
			padding-left: unset;
			border-left: unset;
			border-right: unset;
		}
	}

	.container {
		padding: 0;
	}

	// min-height: 650px;

	.overlay {
		grid-column: span 12;
	}

	.cats-wrapper {
		display: flex;
		flex-direction: row;
		flex-wrap: wrap;
		justify-content: flex-start;
		align-items: center;
		grid-column: span 12;
		margin-bottom: 40px;

		h4 {
			width: 100%;
			margin-bottom: 16px;
			text-transform: capitalize;
		}

		@media (max-width: $tablet) and (orientation: portrait) {
			grid-column: span 12;
		}

		@media (max-width: $tablet) and (orientation: landscape) {
			grid-column: span 12;
		}

		@media (max-width: $mobile) {
			grid-column: span 4;
			/* overflow-x: auto; */
			margin: 0 0 var(--spacer);
			justify-content: flex-start;

			&::-webkit-scrollbar {
				-webkit-appearance: none;
				appearance: none;
				height: 5px;
				background-color: var(--white);
				border-radius: 5px;
			}

			&::-webkit-scrollbar-thumb {
				border-radius: 5px;
				background-color: var(--black);
			}
		}

		.search-container {
			display: flex;
			width: 100%;
			max-width: 50%;
			position: relative;
			align-items: center;
			justify-content: flex-end;

			.search-input {
				width: 100%;
				padding: 15px 50px 12px 25px;
				margin-bottom: 0;
				border: 1px solid var(--duco-blue);
				border-radius: 25px;
				outline: none;
				color: var(--duco-blue);
				line-height: 21px;

				&::-ms-input-placeholder {
					/* Edge 12-18 */
					color: var(--duco-blue);
					padding-top: 15px;
				}

				&::placeholder {
					color: var(--duco-blue);
					padding-top: 15px;
				}
			}

			.search-button {
				position: absolute;
				top: 5px;
				right: 6px;
				width: 40px;
				height: 40px;
				border-radius: 50%;
				background: white;
				display: flex;
				justify-content: center;
				align-items: center;

				svg {
					width: 15px;
				}

				&:hover {
					cursor: pointer;
					background: var(--light-grey);
				}
			}
		}
	}

	.post_tiles {
		column-gap: 40px;
		row-gap: 40px;
		padding-top: 0;
		padding-bottom: 40px;

		@media (max-width: $tablet) and (orientation: portrait) {
			grid-template-columns: repeat(8, 1fr);
			/* column-gap: var(--gutter-tablet-desktop);
			row-gap: var(--gutter-tablet-desktop); */
		}

		@media (max-width: $tablet) {
			grid-template-columns: repeat(12, 1fr);
			/* column-gap: var(--gutter-mobile);
			row-gap: var(--gutter-mobile); */
		}

		@media (max-width: $mobile) {
			grid-template-columns: repeat(4, 1fr);
			/* column-gap: var(--gutter-mobile); */
		}

		.page-numbers {
			@media (max-width: $tablet) and (orientation: portrait) {
				grid-column: span 8;
			}

			@media (max-width: $tablet) and (orientation: landscape) {
				grid-column: span 12;
			}

			@media (max-width: $mobile-xl) {
				grid-column: span 12;
			}

			@media (max-width: $mobile) {
				grid-column: span 4;
			}
		}

		.post_tile {
			&.featured {
				grid-column: span 12;

				@media (max-width: $mobile-xl) {
					grid-column: span 4;
					flex-direction: column;
				}
			}

			grid-column: span 6;

			@media (max-width: $mobile-xl) {
				grid-column: span 4;
				flex-direction: column;
			}
		}
	}

	.title {
		padding: 0 calc(var(--spacer) * 2);
		grid-column: 1 / span 12;

		@media (max-width: $tablet) and (orientation: portrait) {
			grid-column: 1 / span 8;
		}

		@media (max-width: $mobile-xl) {
			padding: 0 calc(var(--spacer) * 1);
		}

		h3 {
			/* color: var(--black); */
			padding-bottom: calc(var(--spacer) * 2);
			margin: 0;
			text-align: center;

			@media (max-width: $mobile-xl) {
				text-align: center;
				font-size: 36px;
				line-height: 44px;
				padding-bottom: calc(var(--spacer) * 1);
			}
		}
	}

	.sort_banner {
		grid-column: 1 / span 12;
		display: grid;
		grid-template-columns: repeat(12, 1fr);
		width: 100%;
		margin-bottom: 0;
		/* margin-top: 40px; */

		&.no-filter {
			@media (min-width: $mobile-xl) {
				padding-top: 40px;
			}
		}

		@media (max-width: $tablet) and (orientation: portrait) {
			grid-column: span 12;
		}

		@media (max-width: $mobile) {
			grid-template-columns: repeat(4, 1fr);
			grid-column: span 4;
			margin-bottom: 0;
		}

		.no-posts {
			padding: 0 calc(var(--spacer) * 2);
			grid-column: 3 / span 8;
			display: flex;
			justify-content: center;
			align-items: center;
			font: normal normal normal 14px/20px var(--primary-font-family);
			color: unset;
			text-transform: unset;
			margin: 0;
			color: var(--black);

			@media (max-width: $mobile) {
				grid-column: 1 / span 4;
				padding: 0 0;
				flex-wrap: wrap;
				gap: 24px;
				width: 100%;
				justify-content: center;
			}

			&.counts {
				p {
					text-decoration: underline;
					font: normal normal normal 14px/18px var(--primary-font-family);
					letter-spacing: 0.28px;
					color: var(--black);
					text-transform: capitalize;
					padding: 0 16px;
					margin: 0;

					&:hover {
						cursor: pointer;
					}

					&.current {
						font: normal normal normal 14px/18px var(--primary-font-family);
					}
				}
			}
		}

		.filter-sort {
			grid-column: 11 / span 2;
			display: flex;
			flex-wrap: wrap;
			flex-direction: row;
			list-style: none;
			margin: 0;
			padding: 0;
			justify-content: flex-end;
			position: relative;
			align-items: center;
			margin-bottom: var(--spacer);

			@media (max-width: $tablet) and (orientation: portrait) {
				grid-column: 10 / span 3;
			}

			&.clicked {
				&::before {
					transform: rotate(180deg);
					transition: 0.2s ease all;
				}
			}

			@media (max-width: $mobile-xl) {
				grid-column: 1 / span 4;
				flex-wrap: wrap;
				grid-row: 1;
				margin-bottom: var(--gutter-tablet-desktop);
			}

			select {
				-webkit-appearance: none;
				-moz-appearance: none;
				appearance: none;
				border-radius: 0;
				opacity: 1;
				padding: 12px calc(16px + 17px + 16px) 12px 16px;
				border: 0;
				outline: none;
				width: 100%;
				grid-column: span 4;
				background-color: white;
				background-image: url('data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIiIGhlaWdodD0iOCIgdmlld0JveD0iMCAwIDEyIDgiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjxwYXRoIGQ9Ik0xIDFMNiA2TDExIDEiIHN0cm9rZT0iIzAwMkY0MSIgc3Ryb2tlLXdpZHRoPSIxLjY2NyIvPgo8L3N2Zz4K');
				background-size: 14px 14px;
				background-position: calc(100% - 16px);
				background-repeat: no-repeat;
				color: var(--black);
				font: normal normal normal 14px/20px var(--primary-font-family);

				option {
					color: var(--black);
					font: normal normal normal 14px/20px var(--primary-font-family);
				}

				&:hover {
					cursor: pointer;
					transition: 0.2s ease all;
				}
			}

			h2 {
				margin-right: calc(var(--spacer) / 2);
				font-weight: bold;

				a {
					text-decoration: none;
					font-weight: bold;

					&:hover {
						cursor: pointer;
					}

					&.current {
						color: var(--black);
					}
				}
			}
		}
	}

	.filter-cats {
		grid-column: span 12;
		width: 100%;
		display: flex;
		flex-direction: row;
		gap: 12px;
		padding: 0;
		justify-content: flex-start;
		align-items: center;
		flex-wrap: wrap;
		margin: 0 0 40px;

		@media (max-width: $mobile) {
			grid-column: span 4;
			width: unset;
			padding: var(--gutter-mobile) var(--gutter-mobile) var(--gutter-mobile) 0;
			justify-content: unset;
			margin: 0;
			white-space: nowrap;
		}

		a {
			display: inline-flex;
			text-decoration: none;
			color: var(--duco-blue);
			font: normal normal normal 20px / 24px var(--primary-font-family);
			transition: 0.2s ease all;
			text-transform: uppercase;

			span {
				color: var(--black);
			}

			@media (hover) {
				&:hover {
					cursor: pointer;
				}
			}

			&::after {
				content: '';
				display: flex;
				width: 2px;
				height: 20px;
				background: var(--duco-blue);
				margin-left: 12px;
			}

			&:last-of-type {
				&::after {
					display: none;
				}
			}

			&:disabled {
				opacity: 0.5;
			}

			&.current {
				cursor: pointer;
				transition: 0.2s ease all;

				span {
					color: white;
				}
			}
		}
	}

	select {
		&.mobile-filter-cats {
			-webkit-appearance: none;
			-moz-appearance: none;
			appearance: none;
			border-radius: 0;
			opacity: 1;
			padding: 12px calc(16px + 17px + 16px) 12px 16px;
			border: 0;
			outline: none;
			width: 100%;
			grid-column: span 4;
			// background-color: white;
			background-image: url('data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIiIGhlaWdodD0iOCIgdmlld0JveD0iMCAwIDEyIDgiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjxwYXRoIGQ9Ik0xIDFMNiA2TDExIDEiIHN0cm9rZT0iIzAwMkY0MSIgc3Ryb2tlLXdpZHRoPSIxLjY2NyIvPgo8L3N2Zz4K');
			background-size: 14px 14px;
			background-position: calc(100% - 16px);
			background-repeat: no-repeat;
			color: var(--black);

			@media (max-width: $tablet) {
				grid-column: span 12;
			}

			@media (max-width: $mobile) {
				grid-column: span 4;
				grid-template-columns: repeat(4, 1fr);
			}

			option {
				color: var(--black);
				font: normal normal normal 14px/20px var(--primary-font-family);
			}

			&:hover {
				cursor: pointer;
				transition: 0.2s ease all;
			}
		}
	}

	.news & {
		select {
			background-color: white;
		}
	}
	// .article_card {
	// 	grid-column: span 4;

	// 	@media (max-width: $tablet) {
	// 		grid-column: span 6;
	// 	}

	// 	@media (max-width: $mobile-xl) {
	// 		grid-column: span 12;
	// 	}
	// }

	.pagination_container {
		display: flex;
		flex-direction: row;
		gap: 68px;
		width: auto;
		justify-content: center;
		align-items: center;
		padding: 0;
		margin: 0;
		grid-column: 1 / span 12;

		@media (max-width: $mobile) {
			gap: 24px;
			grid-column: span 4;
			/* margin-top: 40px;
			margin-bottom: 10px; */
		}
	}

	.page-numbers-exterior {
		text-decoration: none;
		font: normal normal normal 14px/18px var(--primary-font-family);
		display: flex;
		justify-content: center;
		align-items: center;
		color: var(--black);
		background: transparent;
		transition: 0.2s ease all;

		&:hover {
			cursor: pointer;
			transition: 0.2s ease all;

			&:not(.next):not(.prev) {
				background: var(--green);
				color: white;
			}
		}

		&.current {
			transition: 0.2s ease all;
			background: var(--teal-green);
			color: white;
			font: normal normal normal 14px/18px var(--primary-font-family);
		}

		&.next {
			position: relative;

			span {
				display: block;
				font: normal normal normal 14px/18px var(--primary-font-family);
				text-transform: capitalize;
				text-indent: 0;
			}

			svg {
				margin-left: 10px;
				text-indent: 0;
				display: flex;
			}
		}

		&.prev {
			span {
				display: block;
				font: normal normal normal 14px/18px var(--primary-font-family);
				text-transform: capitalize;
				text-indent: 0;
			}

			svg {
				margin-right: 10px;
				text-indent: 0;
				display: flex;
				transform: rotate(-180deg);
			}
		}
	}

	ul.page-numbers {
		padding: 0;

		li {
			display: inline-flex;
			align-items: center;
			justify-content: center;

			.page-numbers {
				text-decoration: none;
				font: normal normal normal 14px/18px var(--primary-font-family);
				width: 32px;
				height: 32px;
				display: flex;
				justify-content: center;
				align-items: center;
				color: var(--black);
				background: transparent;
				transition: 0.2s ease all;
				border-radius: 50%;
				background: transparent;
				border: transparent;

				&:hover {
					cursor: pointer;
					transition: 0.2s ease all;

					&:not(.next):not(.prev) {
						background: var(--green);
						color: var(--black);
					}
				}

				@media (max-width: $mobile) {
					gap: 0;
					width: 24px;
					height: 24px;
					font: normal normal normal 12px/16px var(--primary-font-family);
				}

				&.current {
					transition: 0.2s ease all;
					background: var(--teal-green);
					color: var(--black);
					font: normal normal normal 14px/18px var(--primary-font-family);
					border: var(--border);
				}

				&.next {
					position: relative;
					// overflow: hidden;
					text-indent: -9999px;
					content: '';
					width: 100px;

					/* &:hover {
						svg {
							transform: scale(1.4);
							transition: 0.2s ease all;
						}
					} */

					span {
						display: block;
						font: normal normal normal 16px/24px var(--primary-font-family);
						text-transform: capitalize;
						text-indent: 0;
						position: absolute;
						right: 20px;
					}

					svg {
						position: absolute;
						right: -5px;
						text-indent: 0;
						display: flex;
					}
				}

				&.prev {
					position: relative;
					// overflow: hidden;
					text-indent: -9999px;
					content: '';
					width: 100px;

					/* &:hover {
						svg {
							transform: scale(1.4);
							transition: 0.2s ease all;
						}
					} */

					span {
						display: block;
						font: normal normal normal 16px/24px var(--primary-font-family);
						text-transform: capitalize;
						text-indent: 0;
						position: absolute;
						left: 20px;
					}

					svg {
						position: absolute;
						left: -5px;
						text-indent: 0;
						display: flex;
						transform: rotate(-180deg);
					}
				}
			}
		}
	}

	.news_listing__item {
		&.not_visible {
			display: none;
		}

		&.visible {
			display: flex;
		}
	}
}

.slide-fade-enter-active {
	transition: opacity 0.2s ease;
	transition-delay: 0.3s;
}

.slide-fade-leave-active {
	transition: opacity 0.2s cubic-bezier(1, 0.5, 0.8, 1);
	// transition-delay: .4s;
}

.slide-fade-enter,
.slide-fade-leave-to {
	opacity: 0;
}
</style>



// WEBPACK FOOTER //
// resources/assets/scripts/vue/PostListing.vue